import { ReactNode } from "react";
import { CssBaseline } from "@mui/material";
import { Box } from "@mui/system";
import AppHeaderAdmin from "../../components/Header";
import MetaTags from "components/MetaTags";

type LayoutProps = {
  title?: string;
  children: ReactNode;
};

const Empty = ({ title, children }: LayoutProps) => {
  return (
    <>
      <MetaTags title={title} />
      <div className="admin-layout">
        <CssBaseline />
        <AppHeaderAdmin />
        <Box component="main" className="admin-layout-box-container">
          {children}
        </Box>
      </div>
    </>
  );
};

export default Empty;
